import { useState, useEffect, FC } from 'react';
import classnames from 'classnames';

import { VideoTile } from 'dibs-elements/exports/VideoTile';

import dibsCss from 'dibs-css';
import styles from './HpSharedVideoTile.scss';

type Props = {
    isMobile?: boolean;
    posterOverride: string;
    videoPlaying: boolean;
    videoUrl?: string;
    onVideoStateChange: () => void;
};

export const HpSharedVideoTile: FC<Props> = ({
    isMobile,
    posterOverride,
    onVideoStateChange = () => {},
    videoPlaying,
    videoUrl,
}) => {
    const [currentVideoPlaying, setCurrentVideoPlaying] = useState(false);

    useEffect(() => {
        if (currentVideoPlaying && !videoPlaying) {
            setCurrentVideoPlaying(false);
        }
    }, [currentVideoPlaying, videoPlaying, setCurrentVideoPlaying]);

    if (videoUrl) {
        return (
            <div
                className={classnames(
                    dibsCss.wFull,
                    dibsCss.hFull,
                    dibsCss.flex,
                    dibsCss.justifyCenter,
                    styles.gridImage
                )}
                data-tn="homepage-video"
            >
                <div
                    className={classnames(
                        dibsCss.relative,
                        dibsCss.wFull,
                        dibsCss.hFull,
                        dibsCss.flex,
                        { [dibsCss.mxMedium]: !isMobile }
                    )}
                >
                    <VideoTile
                        animate={currentVideoPlaying}
                        sourceUrl={videoUrl}
                        posterOverride={posterOverride}
                        objectFit="contain"
                        loop={false}
                        muted={false}
                        onPlay={() => {
                            setCurrentVideoPlaying(true);
                            onVideoStateChange();
                        }}
                        onPause={() => {
                            setCurrentVideoPlaying(false);
                            onVideoStateChange();
                        }}
                        controls
                        noBackground
                        noSpinner
                    />
                </div>
            </div>
        );
    } else {
        return null;
    }
};
